"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupCloseButton = void 0;
/*
 * © 2025 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const __1 = require("..");
/** Standard Close button for popups */
const PopupCloseButton = ({ onClose, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement(__1.Button, { onClick: (e) => {
            if (onClose) {
                onClose();
                e.stopPropagation();
            }
        } }, t("button-Close")));
};
exports.PopupCloseButton = PopupCloseButton;
//# sourceMappingURL=CloseButton.js.map